import { PropsWithChildren } from 'react'
import {
  Link as ReactRouterLink,
  LinkProps as ReactRouterLinkProps
} from 'react-router-dom'

type RouterLinkProps = ReactRouterLinkProps &
  React.RefAttributes<HTMLAnchorElement>

/**
 * An anchor that is linking to a route.
 * If you want to use this inside a navigation, use RouterNavLink instead.
 *
 * @param children
 * @param className
 * @param props
 * @constructor
 */
export default function RouterLink({
  children,
  className,
  ...props
}: PropsWithChildren<RouterLinkProps>) {
  const classNames = ['elm-link', className].join(' ').trim()

  return (
    <ReactRouterLink className={classNames} {...props}>
      {children}
    </ReactRouterLink>
  )
}
